export default "__VITE_ASSET__56fb9eda__"